var Apidae_Search = (function() {
    var self = {};
    //var menuCloseCtrl = jQuery('#searchContainer .close-button');

    self.age = function() {
        if (jQuery('#nouisliderAge').length) {
            var sliderAge = document.getElementById('nouisliderAge');
            var minNumberAge = document.getElementById('min-number-age');
            var maxNumberAge = document.getElementById('max-number-age');
            var minRangeAge = document.getElementById('min-range-age');
            var maxRangeAge = document.getElementById('max-range-age');

            noUiSlider.create(sliderAge, {
                start: [minNumberAge.value, maxNumberAge.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangeAge.innerHTML),
                    'max': Number(maxRangeAge.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function(value) {
                        return value + '';
                    },
                    from: function(value) {
                        return value.replace('', '');
                    }
                }
            });

            sliderAge.noUiSlider.on('update', function(values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberAge.value = value;
                } else {
                    minNumberAge.value = value;
                }
            });

            sliderAge.noUiSlider.on('change', function() {
                self.search();
            });

            minNumberAge.addEventListener('change', function() {
                sliderAge.noUiSlider.set([this.value, null]);
            });

            maxNumberAge.addEventListener('change', function() {
                sliderAge.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.ageRbl = function() {
        if (jQuery('#rblAge').length) {
            var rblAge = document.querySelector('#rblAge');
            var cdFiltersRblAge = rblAge.querySelectorAll('.cd-filter-rbl');
            var minNumberAge = document.querySelector('#min-number-age');
            // var maxNumberAge = document.querySelector('#max-number-age');

            cdFiltersRblAge.forEach(function(cdFilterRblAge) {
                cdFilterRblAge.addEventListener('click', function() {
                    minNumberAge.setAttribute('value', this.getAttribute('data-amin'));
                    // maxNumberAge.setAttribute('value', this.getAttribute('data-amax'));
                    self.search();
                })
            });
        }
    };

    self.price = function() {
        if (jQuery('#nouisliderPrice').length) {
            var sliderPrice = document.getElementById('nouisliderPrice');
            var minNumberPrice = document.getElementById('min-number-price');
            var maxNumberPrice = document.getElementById('max-number-price');
            var minRangePrice = document.getElementById('min-range-price');
            var maxRangePrice = document.getElementById('max-range-price');

            noUiSlider.create(sliderPrice, {
                start: [minNumberPrice.value, maxNumberPrice.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangePrice.innerHTML),
                    'max': Number(maxRangePrice.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function(value) {
                        return value + '';
                    },
                    from: function(value) {
                        return value.replace('', '');
                    }
                }
            });

            sliderPrice.noUiSlider.on('update', function(values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberPrice.value = value;
                } else {
                    minNumberPrice.value = value;
                }
            });

            sliderPrice.noUiSlider.on('change', function() {
                self.search();
            });

            minNumberPrice.addEventListener('change', function() {
                sliderPrice.noUiSlider.set([this.value, null]);
            });

            maxNumberPrice.addEventListener('change', function() {
                sliderPrice.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.priceRbl = function() {
        if (jQuery('#rblPrice').length) {
            var rblPrice = document.querySelector('#rblPrice');
            var cdFiltersRblPrice = rblPrice.querySelectorAll('.cd-filter-rbl');
            var minNumberPrice = document.querySelector('#min-number-price');
            var maxNumberPrice = document.querySelector('#max-number-price');

            cdFiltersRblPrice.forEach(function(cdFilterRblPrice) {
                cdFilterRblPrice.addEventListener('click', function() {
                    minNumberPrice.setAttribute('value', this.getAttribute('data-pmin'));
                    maxNumberPrice.setAttribute('value', this.getAttribute('data-pmax'));
                    self.search();
                })
            });
        }
    };

    self.capacity = function() {
        if (jQuery('#nouisliderCapacity').length) {
            var sliderCapacity = document.getElementById('nouisliderCapacity');
            var minNumberCapacity = document.getElementById('min-number-capacity');
            var maxNumberCapacity = document.getElementById('max-number-capacity');
            var minRangeCapacity = document.getElementById('min-range-capacity');
            var maxRangeCapacity = document.getElementById('max-range-capacity');

            noUiSlider.create(sliderCapacity, {
                start: [minNumberCapacity.value, maxNumberCapacity.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangeCapacity.innerHTML),
                    'max': Number(maxRangeCapacity.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function(value) {
                        return value + '';
                    },
                    from: function(value) {
                        return value.replace('', '');
                    }
                }
            });

            sliderCapacity.noUiSlider.on('update', function(values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberCapacity.value = value;
                } else {
                    minNumberCapacity.value = value;
                }
            });

            sliderCapacity.noUiSlider.on('change', function() {
                self.search();
            });

            minNumberCapacity.addEventListener('change', function() {
                sliderCapacity.noUiSlider.set([this.value, null]);
            });

            maxNumberCapacity.addEventListener('change', function() {
                sliderCapacity.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.nombreChambres = function() {
        if (jQuery('#nouisliderNombreChambres').length) {
            var sliderNombreChambres = document.getElementById('nouisliderNombreChambres');
            var minNumberNombreChambres = document.getElementById('min-number-nombreChambres');
            var maxNumberNombreChambres = document.getElementById('max-number-nombreChambres');
            var minRangeNombreChambres = document.getElementById('min-range-nombreChambres');
            var maxRangeNombreChambres = document.getElementById('max-range-nombreChambres');

            noUiSlider.create(sliderNombreChambres, {
                start: [minNumberNombreChambres.value, maxNumberNombreChambres.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangeNombreChambres.innerHTML),
                    'max': Number(maxRangeNombreChambres.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function(value) {
                        return value + '';
                    },
                    from: function(value) {
                        return value.replace('', '');
                    }
                }
            });

            sliderNombreChambres.noUiSlider.on('update', function(values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberNombreChambres.value = value;
                } else {
                    minNumberNombreChambres.value = value;
                }
            });

            sliderNombreChambres.noUiSlider.on('change', function() {
                self.search();
            });

            minNumberNombreChambres.addEventListener('change', function() {
                sliderNombreChambres.noUiSlider.set([this.value, null]);
            });

            maxNumberNombreChambres.addEventListener('change', function() {
                sliderNombreChambres.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.nombreJours = function() {
        if (jQuery('#nouisliderNombreJours').length) {
            var sliderNombreJours = document.getElementById('nouisliderNombreJours');
            var minNumberNombreJours = document.getElementById('min-number-nombreJours');
            var maxNumberNombreJours = document.getElementById('max-number-nombreJours');
            var minRangeNombreJours = document.getElementById('min-range-nombreJours');
            var maxRangeNombreJours = document.getElementById('max-range-nombreJours');

            noUiSlider.create(sliderNombreJours, {
                start: [minNumberNombreJours.value, maxNumberNombreJours.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangeNombreJours.innerHTML),
                    'max': Number(maxRangeNombreJours.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function(value) {
                        return value + '';
                    },
                    from: function(value) {
                        return value.replace('', '');
                    }
                }
            });

            sliderNombreJours.noUiSlider.on('update', function(values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberNombreJours.value = value;
                } else {
                    minNumberNombreJours.value = value;
                }
            });

            sliderNombreJours.noUiSlider.on('change', function() {
                self.search();
            });

            minNumberNombreJours.addEventListener('change', function() {
                sliderNombreJours.noUiSlider.set([this.value, null]);
            });

            maxNumberNombreJours.addEventListener('change', function() {
                sliderNombreJours.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.nombreJoursRbl = function() {
        if (jQuery('#rblNombreJours').length) {
            var rblNombreJours = document.querySelector('#rblNombreJours');
            var cdFiltersRblNombreJours = rblNombreJours.querySelectorAll('.cd-filter-rbl');
            var minNumberNombreJours = document.querySelector('#min-number-nombreJours');
            var maxNumberNombreJours = document.querySelector('#max-number-nombreJours');

            cdFiltersRblNombreJours.forEach(function(cdFilterRblNombreJours) {
                cdFilterRblNombreJours.addEventListener('click', function() {
                    minNumberNombreJours.setAttribute('value', this.getAttribute('data-njmin'));
                    maxNumberNombreJours.setAttribute('value', this.getAttribute('data-njmax'));
                    self.search();
                })
            });

        }
    };

    self.nombreNuits = function() {
        if (jQuery('#nouisliderNombreNuits').length) {
            var sliderNombreNuits = document.getElementById('nouisliderNombreNuits');
            var minNumberNombreNuits = document.getElementById('min-number-nombreNuits');
            var maxNumberNombreNuits = document.getElementById('max-number-nombreNuits');
            var minRangeNombreNuits = document.getElementById('min-range-nombreNuits');
            var maxRangeNombreNuits = document.getElementById('max-range-nombreNuits');

            noUiSlider.create(sliderNombreNuits, {
                start: [minNumberNombreNuits.value, maxNumberNombreNuits.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangeNombreNuits.innerHTML),
                    'max': Number(maxRangeNombreNuits.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function(value) {
                        return value + '';
                    },
                    from: function(value) {
                        return value.replace('', '');
                    }
                }
            });

            sliderNombreNuits.noUiSlider.on('update', function(values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberNombreNuits.value = value;
                } else {
                    minNumberNombreNuits.value = value;
                }
            });

            sliderNombreNuits.noUiSlider.on('change', function() {
                self.search();
            });

            minNumberNombreNuits.addEventListener('change', function() {
                sliderNombreNuits.noUiSlider.set([this.value, null]);
            });

            maxNumberNombreNuits.addEventListener('change', function() {
                sliderNombreNuits.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.distance = function() {
        if (jQuery('#nouisliderDistance').length) {
            var sliderDistance = document.getElementById('nouisliderDistance');
            var minNumberDistance = document.getElementById('min-number-distance');
            var maxNumberDistance = document.getElementById('max-number-distance');
            var minRangeDistance = document.getElementById('min-range-distance');
            var maxRangeDistance = document.getElementById('max-range-distance');

            noUiSlider.create(sliderDistance, {
                start: [minNumberDistance.value, maxNumberDistance.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangeDistance.innerHTML),
                    'max': Number(maxRangeDistance.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function(value) {
                        return value + '';
                    },
                    from: function(value) {
                        return value.replace('', '');
                    }
                }
            });

            sliderDistance.noUiSlider.on('update', function(values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberDistance.value = value;
                } else {
                    minNumberDistance.value = value;
                }
            });

            sliderDistance.noUiSlider.on('change', function() {
                self.search();
            });

            minNumberDistance.addEventListener('change', function() {
                sliderDistance.noUiSlider.set([this.value, null]);
            });

            maxNumberDistance.addEventListener('change', function() {
                sliderDistance.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.duration = function() {
        if (jQuery('#nouisliderDuration').length) {
            var sliderDuration = document.getElementById('nouisliderDuration');
            var minNumberDuration = document.getElementById('min-number-duration');
            var maxNumberDuration = document.getElementById('max-number-duration');
            var minRangeDuration = document.getElementById('min-range-duration');
            var maxRangeDuration = document.getElementById('max-range-duration');

            noUiSlider.create(sliderDuration, {
                start: [minNumberDuration.value, maxNumberDuration.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangeDuration.innerHTML),
                    'max': Number(maxRangeDuration.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function(value) {
                        return value + '';
                    },
                    from: function(value) {
                        return value.replace('', '');
                    }
                }
            });

            sliderDuration.noUiSlider.on('update', function(values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberDuration.value = value;
                } else {
                    minNumberDuration.value = value;
                }
            });

            sliderDuration.noUiSlider.on('change', function() {
                self.search();
            });

            minNumberDuration.addEventListener('change', function() {
                sliderDuration.noUiSlider.set([this.value, null]);
            });

            maxNumberDuration.addEventListener('change', function() {
                sliderDuration.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.elevation = function() {
        if (jQuery('#nouisliderElevation').length) {
            var sliderElevation = document.getElementById('nouisliderElevation');
            var minNumberElevation = document.getElementById('min-number-elevation');
            var maxNumberElevation = document.getElementById('max-number-elevation');
            var minRangeElevation = document.getElementById('min-range-elevation');
            var maxRangeElevation = document.getElementById('max-range-elevation');

            noUiSlider.create(sliderElevation, {
                start: [minNumberElevation.value, maxNumberElevation.value],
                step: 1,
                connect: true,
                range: {
                    'min': Number(minRangeElevation.innerHTML),
                    'max': Number(maxRangeElevation.innerHTML)
                },
                // pips: { // Show a scale with the slider
                //     mode: 'values',
                //     values: [0, 100, 200, 300],
                //     density: 4
                // }
                format: {
                    to: function(value) {
                        return value + '';
                    },
                    from: function(value) {
                        return value.replace('', '');
                    }
                }
            });

            sliderElevation.noUiSlider.on('update', function(values, handle) {

                var value = values[handle];

                if (handle) {
                    maxNumberElevation.value = value;
                } else {
                    minNumberElevation.value = value;
                }
            });

            sliderElevation.noUiSlider.on('change', function() {
                self.search();
            });

            minNumberElevation.addEventListener('change', function() {
                sliderElevation.noUiSlider.set([this.value, null]);
            });

            maxNumberElevation.addEventListener('change', function() {
                sliderElevation.noUiSlider.set([null, this.value]);
            });
        }
    };

    self.search = function() {

        loadData = true;
        var href = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + jQuery("#searchForm").serialize();
        jQuery('.searchBlock input').attr("disabled", true);
        Apidae_Util.ajaxSend();
        //jQuery("html:not(:animated),body:not(:animated)").animate({ scrollTop: Apidae_Layout.gridContainerOffsetTop }, 500);
        //Apidae_Layout.gridScrollBar.mCustomScrollbar("scrollTo", "top");

        jQuery.get(href, function(data) {
            var jqObj = jQuery(data);

            if (history && history.replaceState) {
                history.replaceState({ path: this.path }, '', href);
            }

            jQuery('.TopBar__headline').remove();
            jQuery('.searchBlock').prepend(jqObj.find(".TopBar__headline"));

            jQuery('#searchForm').remove();
            jQuery('.searchBlock').append(jqObj.find("#searchForm"));
            jQuery('#searchBtn').hide();

            var elements = jQuery('.grid .grid__item');
            var items = jQuery(jqObj.find(".grid .grid__item"));

            var newPaginationPager = jQuery(jqObj.find(".paginationPager"));
            jQuery('.paginationPager').remove();
            jQuery('.grid__wrapper .pagination').append(newPaginationPager);

            var newPaginationAjax = jQuery(jqObj.find(".paginationAjax"));
            jQuery('.paginationAjax').remove();
            jQuery('.grid__wrapper .pagination').append(newPaginationAjax);

            imagesLoaded(items, function() {
                jQuery('.grid').empty().append(items);
                Apidae_Map.setMarkers(true);
            });
            // Apidae_Layout.gridIsotope.isotope('remove', elements).append(items).imagesLoaded(function() {
            //     Apidae_Layout.gridIsotope.isotope('appended', items).isotope('layout');
            //     //Apidae_Layout.loadSlider();
            //     Apidae_Layout.gridIsotope.isotope();
            //     Apidae_Map.setMarkers(false);
            // }); 

            //menuCloseCtrl.trigger('click');
            //jQuery(window).scrollTop(jQuery(window).scrollTop()+1); 
            self.dropdown();
            self.price();
            self.ageRbl();
            self.priceRbl();
            self.capacity();
            self.nombreChambres();
            self.nombreJours();
            self.nombreJoursRbl();
            self.nombreNuits();
            self.distance();
            self.duration();
            self.elevation();
            loadData = false;
            Apidae_Util.ajaxComplete();
        });

    };

    self.dropdown = function() {
        // Dropdowns filter

        /* for keeping track of what's "open" */
        var activeClass = 'dropdown-active',
            showingDropdown, showingMenu, showingParent;
        /* hides the current menu */
        var hideMenu = function() {
            if (showingDropdown) {
                //console.log(showingDropdown);
                showingDropdown.removeClass(activeClass);
                //showingMenu.hide();
            }
        };

        /* recurse through dropdown menus */
        jQuery('.searchBlock .cd-filter-block h4').each(function() {
            /* track elements: menu, parent */
            var dropdown = jQuery(this);
            var menu = dropdown.next('.cd-filter-content'),
                parent = dropdown.parent(),
                filter = menu.find('.filter');
            /* function that shows THIS menu */
            var showMenu = function() {
                hideMenu();
                showingDropdown = dropdown.addClass(activeClass);
                showingParent = parent;
            };
            /* function to show menu when clicked */
            dropdown.on('click', function(e) {
                // console.log(e);
                if (e) e.stopPropagation();
                if (e) e.preventDefault();

                if (dropdown.hasClass(activeClass)) {
                    hideMenu();
                } else {
                    showMenu();
                }
            });

        });

        /* hide when clicked outside */
        jQuery(document.body).on('click', function(e) {
            if (showingParent) {
                var parentElement = showingParent[0];
                var dropdownElement = showingDropdown[0];
                if (!jQuery.contains(parentElement, e.target) || !parentElement == e.target) {
                    hideMenu();
                }
            }
        });
    };

    self.init = function() {
        // hide search button when javascript enabled
        jQuery('#searchBtn').hide();

        //toggle filter block dropdown mobile
        jQuery('.sidebar-filter').on('click', '.searchBlockHeaderBtn', function() {
            jQuery(".searchBlockContent").animate({
                height: 'toggle'
            }, 1000, function() {
                // Animation complete.
            });
            jQuery(this).toggleClass("highlight");
            jQuery('#searchButton .fa-chevron-down, #searchButton .fa-chevron-up').toggle();
        });

        self.dropdown();
        self.price();
        self.ageRbl();
        self.priceRbl();
        self.capacity();
        self.nombreChambres();
        self.nombreJours();
        self.nombreJoursRbl();
        self.nombreNuits();
        self.distance();
        self.duration();
        self.elevation();

        // calendar search
        jQuery('.searchBlock').on('focus', '#fieldDate input[type=text]', function() {
            jQuery(this).select();
            jQuery(this).pikaday({
                firstDay: 1,
                format: 'DD/MM/YYYY',
                i18n: {
                    previousMonth: 'Previous Month',
                    nextMonth: 'Next Month',
                    months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
                    weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
                    weekdaysShort: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
                },
                onSelect: function() {
                    self.search();
                }
            });
            jQuery('input[value=calendar]').attr('checked', true);
        });

        // search + map (ajax)
        jQuery(document.body).on('click', '.searchBlock input.filter', function() {
            self.search();
        });

        // checked critere de recherche en déplaçant la carte
        jQuery("#searchByMap").on('change', function() {
            var critereSearchByMap = jQuery("#searchByMap").is(':checked');
            //console.log(critereSearchByMap);
            if (critereSearchByMap) {
                jQuery("#critereSearchByMap").val(1).attr('checked', true);
            } else {
                jQuery("#critereSearchByMap").val(0).attr('checked', false);
            }
        });

        // search (Critères de tri)
        jQuery('#tri').on('change', function() {
            var critereTri = jQuery(this).val();
            jQuery('#critereTri').val(critereTri);
            self.search();
        });

    };

    return self;
})();

jQuery(window).on("load", function() {
    Apidae_Search.init();
});